import React from 'react';
import { motion } from 'framer-motion';
import './Experience.css';
import waterImage from '../assets/water.jpg';

const Experience = () => {
  const experiences = [
    {
      title: 'Founder',
      company: 'Solutionspath Technology Pvt. Ltd',
      period: 'Present',
      description: 'Leading a tech startup with a business partner, developing innovative solutions.'
    },
    {
      title: 'Junior Software Engineer',
      company: 'Teclainfrastructure',
      period: 'Previous',
      description: 'Developed software solutions and contributed to infrastructure projects.'
    },
    {
      title: 'Flutter Intern',
      company: 'mbank Technology',
      period: 'Internship',
      description: 'Gained experience in mobile app development using Flutter framework.'
    }
  ];

  return (
    <motion.div
      className="experience"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <motion.div
          className="experience-header"
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <img src={waterImage} alt="Experience Journey" className="experience-image" />
          <h2>My Experience</h2>
        </motion.div>
        <div className="experience-timeline">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              className="experience-item"
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.2, duration: 0.8 }}
            >
              <div className="experience-content">
                <h3>{exp.title}</h3>
                <h4>{exp.company}</h4>
                <p className="period">{exp.period}</p>
                <p>{exp.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;